import { QuoteOkData } from 'charting_library_trading_platform/charting_library';

import { AbstractBroker } from './AbstractBroker';

let chartBroker: AbstractBroker | undefined;
export const setChartBroker = (broker: AbstractBroker) => {
  chartBroker = broker;
};
export const getChartBroker = () => {
  return chartBroker;
};

export const brokerCallbacks: {
  closePosition: {
    resolve: ((value: boolean) => void) | undefined;
    reject: ((reason?: unknown) => void) | undefined;
  };
} = {
  closePosition: {
    resolve: undefined,
    reject: undefined,
  },
};

export const chartQuotesSubscriptionsIDToCallbackMap = new Map<
  string,
  {
    symbols: string[];
    markEnabledSymbols: string[];
    onRealtimeCallback: (data: QuoteOkData[]) => {};
  }
>();

export const chartQuotesSubscriptionsSymbolToIDMap = new Map<string, string[]>();
